import { MMKV } from 'react-native-mmkv'

const mmkvStorage = new MMKV()

async function saveObject(key: string, value: any): Promise<void> {
  try {
    mmkvStorage.set(key, JSON.stringify(value))
  } catch (error) {
    console.log('failed to save object')
  }
}

async function getObject(key: string): Promise<any | null> {
  try {
    const data = mmkvStorage.getString(key)
    if (data) {
      return JSON.parse(data)
    }
  } catch (error) {
    console.log('failed to get object')
  }
  return null
}

async function deleteObject(key: string): Promise<any | null> {
  try {
    mmkvStorage.delete(key)
  } catch (error) {
    console.log('failed to delete object')
  }
}

function nonAsyncSaveObject(key: string, value: any) {
  mmkvStorage.set(key, JSON.stringify(value))
}

function nonAsyncGetObject(key: string) {
  const data = mmkvStorage.getString(key)
  if (data) {
    return JSON.parse(data)
  }

  return null
}

const storageUtil = {
  mmkvStorage,
  getObject,
  saveObject,
  deleteObject,
  nonAsyncSaveObject,
  nonAsyncGetObject,
}
export default storageUtil
